<div class="page">
  <h1>Check-In-Anzeigen</h1>
  <p class="hint">
    Pro Raum ein Tablet oder Handy, das den wechselnden QR-Code für den Check-In zeigt.
    Nach dem Anlegen den Einrichtungs-Link auf dem Gerät öffnen (oder den QR-Code damit scannen);
    danach bleibt die Anzeige eingerichtet.
  </p>

  <form class="new" (ngSubmit)="add()">
    <input type="text" name="label" [(ngModel)]="label" placeholder="Bezeichnung, z. B. Tablet Tanzsaal" maxlength="100" required>
    <select name="pid" [(ngModel)]="pid">
      @for (room of rooms; track room.pid) {
        <option [ngValue]="room.pid">{{ room.name }}</option>
      }
    </select>
    <button type="submit" class="button-add" [disabled]="!label.trim()">Neue Anzeige</button>
  </form>

  @if (created) {
    <div class="created">
      <h2>„{{ created.label }}“ angelegt</h2>
      <p>Diesen Link auf dem Anzeige-Gerät öffnen. Er wird nur jetzt angezeigt.</p>
      <img [src]="created.qr" alt="Einrichtungs-Link als QR-Code">
      <div class="link">
        <code>{{ created.url }}</code>
        <button type="button" class="button-add" (click)="copy()">{{ copied ? 'Kopiert' : 'Kopieren' }}</button>
      </div>
      <button type="button" class="button-close" (click)="created = undefined">Schließen</button>
    </div>
  }

  <table>
    <thead>
      <tr><th>Bezeichnung</th><th>Angelegt</th><th>Zuletzt aktiv</th><th></th></tr>
    </thead>
    <tbody>
      @for (display of displays; track display.id) {
        <tr>
          <td>{{ display.label }}</td>
          <td>{{ display.created_at | date: 'dd.MM.yyyy HH:mm' }}</td>
          <td>{{ display.last_seen_at ? (display.last_seen_at | date: 'dd.MM.yyyy HH:mm') : '–' }}</td>
          <td><button type="button" class="button-remove" (click)="revoke(display)">Sperren</button></td>
        </tr>
      } @empty {
        <tr><td colspan="4">Noch keine Anzeigen eingerichtet.</td></tr>
      }
    </tbody>
  </table>
</div>
